import * as api from '../api'
import { CREATE_NOTATION, DELETE_NOTATION, UPDATE_NOTATION } from '../constants/actionTypes.js'

// Action creator
export const createSurvey = (survey, match) => async (dispatch, getState) => {
    try {

        const newSurvey = survey
        newSurvey.creation = Date.now()
        newSurvey.idMatch = match.idMatch ? match.idMatch : match.idActu
        if(newSurvey.timer === undefined)
            newSurvey.timer = !match.timer ? 0 : match.timer === 0 ? (Math.floor(match.timer/60))*60 : (Math.floor((match.timer + 60)/60))*60
        if(newSurvey.period === undefined)
            newSurvey.period = match.period ? match.period : 0

        const { data } = await api.createSurvey(newSurvey)

        console.log('created survey', data);

        return data;

        //dispatch( { type : CREATE_NOTATION, payload: data })
    } catch(error){
        console.log(error)
        throw error;
    }
}

/*
export const addNote = (id, note) => async (dispatch, getState) => {
    try {
        const { data } = await api.addNote(id, {note : note})

        //dispatch({ type : UPDATE_NOTATION, payload: data})
    } catch(error){
        console.log(error.message)
    }
}*/

export const updateSurvey = (surveyDetail, id) => async (dispatch, getState) => {
    try {
        const { data } = await api.updateSurvey(id, surveyDetail)

        console.log('updated survey', data);

        return data;

        //dispatch({ type : UPDATE_NOTATION, payload: data})
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const deleteSurvey = (id) => async (dispatch) => {
    try {
        await api.deleteSurvey(id)

        //dispatch({ type : DELETE_NOTATION, payload: id})
    }catch(error){
        console.log(error)
        throw error;
    }
}